{
  "pageTitle": "Adrese",
  "addAddress": "Dodaj adresu",
  "addShort": "Dodaj",
  "editAddress": "Uredi adresu",
  "noAddressesYet": "Još nema adresa",
  "noAddressesHint": "Dodajte prvu adresu da dodijelite pružatelje i pokrenete skupljanje.",
  "noProvidersAvailable": "Nema dostupnih pružatelja",
  "providersCount": "{{count}} pružatelja",
  "manageProviders": "Upravljaj pružateljima",
  "hideProviders": "Sakrij pružatelje",
  "assignProvider": "Dodijeli pružatelja",
  "assignProviderFirst": "Dodaj prvog pružatelja",
  "editProvider": "Uredi pružatelja",
  "removeProvider": "Ukloni",
  "selectProvider": "Odaberi pružatelja",
  "newPasswordHint": "Nova lozinka (ostavite prazno da zadržite)",
  "passwordSet": "Lozinka je postavljena",
  "save": "Sačuvaj",
  "cancel": "Otkaži",
  "assign": "Dodijeli",
  "deleteConfirm": "Obrisati ovu adresu?",
  "saveError": "Čuvanje nije uspjelo",
  "deleteError": "Brisanje nije uspjelo",
  "assignError": "Dodjela nije uspjela",
  "removeError": "Uklanjanje nije uspjelo",
  "updateError": "Ažuriranje nije uspjelo",
  "deleteConfirmPrompt": "Da li ste sigurni da želite obrisati ovu adresu?",
  "placeholder": {
    "addressName": "npr. Kuća, Kancelarija",
    "username": "Korisničko ime",
    "password": "Lozinka",
    "accountKeyword": "npr. ASA Banka d.d. Sarajevo",
    "taxDeductionAmount": "Iznos",
    "invoiceEmailTo": "npr. ime@primjer.com"
  },
  "label": {
    "skipPayment": "Preskoči plaćanje",
    "taxDeduction": "Omogući poreski odbitak",
    "meterReadingEnabled": "Koristi za očitanja brojila",
    "invoiceEmailTo": "Šalji nove račune e-mailom na"
  }
}
